import React, { useState } from 'react'
import './Search.scss'
import { FiSearch } from "react-icons/fi";

const Index = ({ searchCallBack, placeholder, className, inputRef, handleSubmit }: any) => {
    const [ searchValue, setSearchValue  ] = useState('')
    let debounce: any;
    const handleSearch = (e: any) => {
        clearTimeout(debounce)
        debounce = setTimeout(() => {
            setSearchValue(e)
            searchCallBack(e)
        }, 1000);
    }
    return (
        <>
            <div className="position-relative">
                <form onSubmit={(e)=>{e.preventDefault(); handleSubmit(searchValue); setSearchValue('')}}>
                <span className='position-absolute search-icon'><FiSearch /></span>
                <input
                    className={[className,].join(' ')}
                    autoComplete="off"
                    type="text"
                    name="keyword"
                    id="search"
                    placeholder={placeholder ? placeholder : 'Search'}
                    // defaultValue={searchKeyword}
                    ref={inputRef}
                    onChange={(e) => {
                        handleSearch(e.target.value);
                    }}
                />
                </form>
            </div>
        </>

    )
}

export default Index